<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.mechanicalInspection_Tolerance"
      >
        <span
          class="col-form-label"
        >Determine the min/max or acceptable tolerance range from manufacturer</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.mechanicalInspection_Dimensions"
      >
        <span class="col-form-label">Measure, verify and record package dimensions</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.mechanicalInspection_ThicknessVariation"
      >
        <span class="col-form-label">Measure for thickness variation</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaMechanicalDetailed',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        mechanicalInspection_Tolerance: this.inspectionDetails[FIELDS.MECHANICAL_INSPECTION__TOLERANCE] || '',
        mechanicalInspection_Dimensions: this.inspectionDetails[FIELDS.MECHANICAL_INSPECTION__DIMENSIONS] || '',
        mechanicalInspection_ThicknessVariation: this.inspectionDetails[FIELDS.MECHANICAL_INSPECTION__THICKNESS_VARIATION] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>